import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "react-router-dom";

const CategoryOne = () => {
  const categories = [
    {
      id: 1,
      title: "Home Printers",
      subtitle: "Perfect for everyday printing",
      imgSrc: "/assets/img/category/home-printer.jpg",
    },
    {
      id: 2,
      title: "Office Printers",
      subtitle: "Built for business efficiency",
      imgSrc: "/assets/img/category/office-printer.jpg",
    },
    {
      id: 3,
      title: "Laser Printers",
      subtitle: "Fast, sharp & professional",
      imgSrc: "/assets/img/category/laser-printer.jpg",
    },
    {
      id: 4,
      title: "Ink, Toner & Paper",
      subtitle: "Essentials for smooth printing",
      imgSrc: "/assets/img/category/office-printer.jpg",
    },
    {
      id: 5,
      title: "Inkjet Printers",
      subtitle: "Vibrant colors & photo-quality",
      imgSrc: "/assets/img/category/inkjet-printer.jpg",
    },
  ];

  return (
    <section className="category-premium">
      <div className="container">
        {/* Heading */}
        <div className="title-block text-center">
          <h2 className="heading-xl">Explore Our Printer Categories</h2>
          <p className="heading-sub">
            Find the perfect printer or essential supplies tailored to your
            needs — from compact home models to powerful office solutions.
          </p>
          <div className="heading-underline mb-5"></div>
        </div>

        {/* Slider */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500 }}
          loop={true}
          slidesPerView={1}
          spaceBetween={35}
          breakpoints={{
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
            1400: { slidesPerView: 5 },
          }}
          className="premium-slider"
        >
          {categories.map((cat) => (
            <SwiperSlide key={cat.id}>
              <Link to="/shop" className="premium-card">
                <div className="premium-img">
                  <img src={cat.imgSrc} alt={cat.title} loading="lazy" />
                </div>
                <h3>{cat.title}</h3>
                <p>{cat.subtitle}</p>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* -------- PREMIUM STYLES -------- */}
      <style>{`
        .category-premium {
          padding: 90px 0;
          background: #f9fafb;
        }

        /* HEADINGS */
        .heading-xl {
          font-size: 36px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 10px;
        }

        .heading-sub {
          font-size: 16px;
          color: #64748b;
          max-width: 600px;
          margin: 0 auto 12px auto;
        }

        .heading-underline {
          width: 60px;
          height: 3px;
          background: #4C8BF5;
          margin: 18px auto 0 auto;
        }

        /* CARD DESIGN */
        .premium-card {
          background: #ffffff;
          border-radius: 14px;
          border: 1px solid #e2e8f0;
          padding: 30px 20px;
          text-align: center;
          cursor: pointer;
          position: relative;
          transition: all 0.35s ease;
          box-shadow: 0px 3px 10px rgba(0,0,0,0.04);
        }

        .premium-card:hover {
          transform: translateY(-10px);
          box-shadow: 0px 12px 24px rgba(0,0,0,0.1);
          border-color: #4C8BF5;
        }

        .premium-img {
          width: 110px;
          height: 110px;
          margin: 0 auto 15px auto;
          overflow: hidden;
          border-radius: 10px;
          background: #f1f5f9;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .premium-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .premium-card:hover img {
          transform: scale(1.08);
        }

        .premium-card h3 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 6px;
          color: #0f172a;
        }

        .premium-card p {
          font-size: 14px;
          color: #64748b;
          margin-bottom: 0;
        }
      `}</style>
    </section>
  );
};

export default CategoryOne;
